// @ts-nocheck
import React from "react";

// Style
import "./Tile.scss";

// Classnames
import clsx from "clsx";

// Components
import Img from "components/Img";

// Interface
interface ITile {
  mg?: string,
  type?: any,
  price?: any,
  label?: string,
  value?: string,
  available?: boolean,
  priceUsd?: number,
  priceEur?: number,
  current?: string | number,
  // onClick?: (value: {
  //   mg: number | string | undefined;
  //   type: string | number | undefined;
  //   price: string | number | undefined;
  //   value: string | number | undefined;
  // }) => void;
  onClick?: any;
}

export const Tile: React.FC<ITile> = (props) => {
  let available: string = "";
  let currentTile: string = "";

  if (props?.current === props.value) {
    currentTile = "tile--current";
  }

  if (props.available) {
    available = "tile--active";
  }

  const typePrice = props[`price${props?.type}`];

  const handlerClick = (data: string) => () => {
    if (!available) {
      return null;
    }

    return props.onClick &&
      props.onClick({
        value: data,
        mg: props.mg,
        price: typePrice,
        type: props.type
      });
  };

  const cn = clsx(
    "tile",
    available,
    currentTile
  );

  return typePrice ? (
    <div
      className={cn}
      onClick={handlerClick(`price${props.mg}mg`)}
    >
      {props.mg && <p className="tile__label">{props.mg}mg</p>}
      {typePrice && <p className="tile__price">${typePrice}</p>}

      {!!currentTile && <Img
        isSvg
        name="doneWhiteSvg"
        className="tile__icon"
      />}
    </div>
  ) : <></>;
};

export default Tile;